import MobileCarousel from '@sharedComponent/carousel/MobileCarousel';
import ImageComponent from '@sharedComponent/image-component';
import EdenredTypo from '@sharedComponent/typography';
import { Col, Row } from 'antd';
import React from 'react';
import { images } from 'src/assets/img';
import './leave-status-mobile.scss';

function LeaveStatusMobile({ currentLeave, onGoingLeave, countLoader }) {
	if (countLoader) return <div>loading</div>;

	return (
		<Row className="main-class-leavestatus">
			<Col xs={24}>
				<div>
					<ImageComponent src={images.edenredSVG} style={{ width: '80px' }} />
				</div>
			</Col>
			<Col xs={24} className="main-title-container">
				<EdenredTypo className="medium Main-title-leave-status">Leave Statuses</EdenredTypo>
			</Col>
			<Col xs={24} className="carosuel-card-leave">
				<MobileCarousel
					title="Currently on leave"
					data={currentLeave || []}
					slidesPerRow={4}
					slidesToShow={1}
					slidesToScroll={1}
					dots={true}
				/>
			</Col>
			<Col xs={24} className="carosuel-card-leave">
				<MobileCarousel title="Going on leave" data={onGoingLeave} slidesPerRow={4} slidesToShow={1} slidesToScroll={1} dots={true} />
			</Col>
		</Row>
	);
}

export default LeaveStatusMobile;
